module.exports = __webpack_public_path__ + "static/img/m-banner-1.6a0f2fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m-banner-1.jpg
// module id = qtfp
// module chunks = 1